import React, { useEffect, useRef } from 'react'

import { Col, Row } from 'antd'

import usePageTitle from '../../../hooks/usePageTitle'
import AuthenticatedLayout from '../components/AuthenticatedLayout'

import ComponentMenu from './components/ComponentMenu'
import ManageTeamNavigator from './components/ManageTeamNavigator'

const patchCollapseIcons = container => {
  const icons = container.querySelectorAll(
    '.team-management-panel .ant-collapse-header > .ant-collapse-arrow',
  )
  icons.forEach(icon => {
    icon.setAttribute('aria-hidden', 'true')
    icon.removeAttribute('aria-label')
  })
  return icons.length > 0
}

const ManageTeam = () => {
  usePageTitle('Manage Team')
  const containerRef = useRef(null)

  useEffect(() => {
    if (patchCollapseIcons(containerRef.current)) return

    const observer = new MutationObserver(() => {
      if (patchCollapseIcons(containerRef.current)) observer.disconnect()
    })
    observer.observe(containerRef.current, { childList: true, subtree: true })

    return () => observer.disconnect()
  }, [])

  return (
    <AuthenticatedLayout title="Manage Team" gutters={true}>
      <div className="max-1200" ref={containerRef}>
        <Row type="flex" align="top" gutter={16}>
          <Col xs={{ span: 24 }} md={{ span: 6 }}>
            <ComponentMenu />
          </Col>
          <Col xs={{ span: 24 }} md={{ span: 18 }}>
            <ManageTeamNavigator />
          </Col>
        </Row>
      </div>
    </AuthenticatedLayout>
  )
}

export default ManageTeam
